<div class="modal">
  <!-- Modal content -->
  <div class="modal-content" [ngClass]="increaseModalWidth ? 'expanded-modal' : 'show-modal'">
    <ng-content></ng-content>
  </div>
</div>
